export const SITE_URL = 'https://profiteksvl.ru';
export const SITE_TITLE = 'Профитекс';
export const MAIN_EMAIL = 'info@profiteksvl.ru';
export const MAIN_PHONE = '+7 (950) 299-86-92';
